import React from "react";
import {
  Card,
  FieldError,
  H2,
  isInvalid,
  theme,
} from "@reside/ui";

import {Switch} from "../../atoms/switch";
import {SectionBlock, SectionInstruction} from "./styles";
import {SSO_MANAGEMENT_FORM_FIELDS} from "./constants";
import type {FormikProps} from "formik";
import type {SsoFormikValues} from "./confirmationModalConstants";

type Props = Readonly<{
  ssoEnabled: boolean;
  onStatusChange: (enabled: boolean) => void;
  form: FormikProps<SsoFormikValues>;
}>;

export const SSOStatusCard = ({
  ssoEnabled,
  onStatusChange,
  form,
}: Props): JSX.Element => (
  <Card style={{padding: theme.space[7]}}>
    <SectionBlock>
      <H2>Switch SSO on or off for this organization</H2>
      <SectionInstruction>
        If SSO is switched on you can then choose for selected users to sign in
        via SSO.
      </SectionInstruction>
      <FieldError name={SSO_MANAGEMENT_FORM_FIELDS.SSO_ENABLED} />
      <Switch
        checked={ssoEnabled}
        onChange={onStatusChange}
        error={isInvalid(SSO_MANAGEMENT_FORM_FIELDS.SSO_ENABLED, form)}
        label={
          ssoEnabled
            ? "SSO is switched on for this organization."
            : "SSO is switched off for this organization."
        }
        data-test-id="sso-status-switch"
      />
    </SectionBlock>
  </Card>
);
